export const FlagEEIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="100%"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill="#fff"
        fillRule="nonzero"
        d="M256.001 19.596c65.278 0 124.383 26.466 167.163 69.243 42.776 42.779 69.243 101.884 69.243 167.162s-26.467 124.383-69.246 167.16c-42.777 42.779-101.882 69.246-167.16 69.246-65.278 0-124.383-26.467-167.162-69.243-42.777-42.78-69.243-101.885-69.243-167.163S46.062 131.618 88.839 88.839c42.779-42.777 101.884-69.243 167.162-69.243z"
      />
      <path d="M459.519 329.725H52.483c-8.337-23.012-12.889-47.836-12.889-73.724 0-25.983 4.583-50.894 12.978-73.975H459.43c8.395 23.081 12.979 47.992 12.979 73.975 0 25.888-4.553 50.712-12.89 73.724z" />
      <path
        fill="#0072CE"
        d="M459.431 182.026H52.571C82.792 98.938 162.462 39.594 256.001 39.594c93.536 0 173.209 59.344 203.43 142.432z"
      />
    </svg>
  );
};
